module.exports = __webpack_public_path__ + "static/media/room-feature-guests.16e8e29a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/room-feature-guests.svg
// module id = 216
// module chunks = 9